<template>
  <!--
    EVENTS
      - closed: the modal has closed
      - exited: the user clicked the X on the modal
    SLOTS
      - NORMAL - this is the content of the modal
      - actions - this is where you will put some actions for the modal
  -->
  <div class="basic-modal" v-if="isVisible">
    <div class="basic-modal__container" ref="container" :style="modalStyle">
      <template v-if="enableCloseButton">
        <div class="basic-modal__close-btn" @click="clickedExit" >
          <svg-icon :icon="cancel" :width="12" :height="12"></svg-icon>
        </div>
      </template>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import cancel from '@/assets/svg/cancel.svg'
const HEIGHT_OF_ACTIONS = 52
const PADDING_OF_MODAL = 44 // equal to 2 * border of __container + 2 * padding of __content

export default {
  components: {
    SvgIcon
  },
  props: {
    showOnCreate: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    cssAfectsWidth: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: Number,
      default: null
    },
    // if you click not in the container modal area, it will close the modal
    enableClickClose: {
      type: Boolean,
      default: false
    },
    /**
     * If you want to have the option for the X circle to close the modal
     */
    enableCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: this.showOnCreate,
      cancel
    }
  },
  computed: {
    modalStyle () {
      let style = {}
      if (this.cssAfectsWidth) {
        style.width = this.width ? String(this.width) + 'px' : null
      }
      if (this.autoWidth) {
        style.maxWidth = 'none'
      }
      if (this.minHeight) {
        style['min-height'] = String(this.minHeight) + 'px'
      }
      return style
    }
  },
  methods: {
    /**
     * This will extend a scrolling to the selected elements,  this is used when you want to
     * view the entire array of seletable items in the modal, when somtimes it can be hard to see
     * of even scroll to the end of the modal to view these items on the modal itself
     */
    extendScroll (cssSelector) {
      setTimeout(() => {
        if (this.$el.getElementsByClassName) {
          let content = this.$el.getElementsByClassName('basic-modal__content')[0]
          let elements = content.getElementsByClassName(cssSelector)
          for (let element of elements) {
            element.addEventListener('click', function () {
              setTimeout(() => {
                content.scrollBy(0, 200)
              }, 30)
            })
          }
        }
      }, 30)
    },
    open () {
      this.isVisible = true
      if (this.enableClickClose) {
        window.addEventListener('click', this.handleDocumentClick, true)
      }
    },
    clickedExit () {
      this._close()
      this.$emit('exited')
    },
    close () {
      this._close()
      this.$emit('closed')
    },
    _close () {
      if (!this.isVisible) return
      this.isVisible = false
      if (this.enableClickClose) {
        window.removeEventListener('click', this.handleDocumentClick, true)
      }
    },
    toggle () {
      !this.isVisible ? this.open() : this.close()
    },
    handleDocumentClick (e) {
      if (!this.$el.getElementsByClassName('basic-modal__container')[0].contains(e.target)) {
        this.close()
      }
    }
  }
}

</script>

<style lang="scss">
  $curves: 40px;
  $shadow: 4px;

  .basic-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    @if ($z-modal) {
      z-index: $z-modal;
    } @else {
      z-index: 10999;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;

    &__container {
      z-index: 50;
      background: white;
      max-width: 800px;
      max-height: 90%;
      @include drop-shadow;
      display: flex;
      flex-direction: column;
      border: 2px solid black;
      border-radius: $curves;
      box-shadow: $shadow $shadow $shadow $shadow #777777;
      overflow-x: hidden;
      position: relative;
    }

    &__close-btn {
      display: flex;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      background: #000000;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 65;

      svg {
        fill: white
      }
    }
  }

</style>



// WEBPACK FOOTER //
// BasicModal.vue?a6e3e358